import moment from "moment";
import React, { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import styled from "styled-components";
import { CheckboxInput, CheckboxInputProps } from "./CheckboxInput";
import { InputErrorMessage } from "./InputErrorMessage";

const StyledWeekdays = styled.fieldset`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;

    > * {
        flex: 0 1 100px;
    }
`;

interface Props extends CheckboxInputProps {
    single?: true;
}

export const WeekdayInput = ({ name, label, single }: Props) => {
    const weekdays = moment.weekdays(true);

    return (
        <div className="form-group">
            {label && <label>{label}</label>}
            <StyledWeekdays>
                {Array(7)
                    .fill(true)
                    .map((_, i) => (
                        <CheckboxInput
                            key={i}
                            name={single ? name : name + "." + i}
                            value={single ? i : undefined}
                            label={weekdays[i]}
                            type={single ? "radio" : "checkbox"}
                            showNoError={single}
                        />
                    ))}
            </StyledWeekdays>
            <InputErrorMessage name={name} />
        </div>
    );
};

const RadioButton = {};
